import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal modal--user",
  id: "modal-complaint"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-header" }
const _hoisted_7 = { class: "modal-title" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "modal-content" }
const _hoisted_10 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_11 = {
  key: 0,
  class: "flashmessage flash-success"
}
const _hoisted_12 = {
  key: 1,
  class: "flashmessage flash-danger"
}
const _hoisted_13 = { class: "form-section" }
const _hoisted_14 = { for: "frm-complaintForm_message" }
const _hoisted_15 = {
  key: 0,
  class: "form-error"
}
const _hoisted_16 = { class: "form-footer" }
const _hoisted_17 = { class: "buttons-inline" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "modal-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "modal-close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('AdComplaint.title')), 1),
              _createElementVNode("div", {
                innerHTML: _ctx.$t('AdComplaint.subtitle', { title: _ctx.title, adFrontId: _ctx.adFrontId, generalTermsUrl: _ctx.generalTermsUrl, domain: _ctx.domain })
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("form", {
                id: "complaint-form",
                class: "form",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"])),
                autocomplete: "off"
              }, [
                (_ctx.showFormMessages)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_ctx.isSuccess)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('AdComplaint.success-message', { domain: _ctx.domain })), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "flashmessage flash-danger"
                        }, _toDisplayString(error), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.message.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('AdComplaint.reason')) + ":", 1),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.message.$model) = $event)),
                      name: "frm-complaintForm_message",
                      class: "form-control",
                      rows: "5"
                    }, " ", 512), [
                      [_vModelText, _ctx.v$.form.message.$model]
                    ]),
                    (_ctx.v$.form.message.$dirty && _ctx.v$.form.message.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.message.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      class: "button button--primary",
                      disabled: _ctx.isSuccess
                    }, _toDisplayString(_ctx.$t('AdComplaint.button-send')), 9, _hoisted_18)
                  ])
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}